<template>
	<v-dialog v-model="dialogState" max-width="1200px">
		<v-card elevation="0" :loading="uploading_form">
			<v-card-text class="pb-0">
				<v-tabs v-model="step" grow center-active>
					<v-tab>
						<v-badge
							color="yellow darken-3"
							:content="clientFilters"
							:value="clientFilters"
							>Cliente
						</v-badge>
					</v-tab>
					<v-tab>
						<v-badge
							color="yellow darken-3"
							:content="attentionFilters"
							:value="attentionFilters"
							>Atenciones
						</v-badge>
					</v-tab>
					<!-- <v-tab>
						<v-badge
							color="yellow darken-3"
							:content="contractFilters"
							:value="contractFilters"
							>Contrato
						</v-badge>
					</v-tab> -->
					<v-tabs-items v-model="step">
						<v-tab-item class="pb-5">
							<ClientDataFilters />
						</v-tab-item>
						<v-tab-item class="pb-5">
							<AttentionDataFilters />
						</v-tab-item>
						<!-- <v-tab-item class="pb-5">
							<ContractDataFilters />
						</v-tab-item> -->
					</v-tabs-items>
				</v-tabs>
			</v-card-text>

			<v-card-actions class="mt-n6 mx-2">
				<v-row no-gutters>
					<v-col cols="12" md="8">
						<v-btn
							outlined
							color="error"
							:width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
							:class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
							@click="clearform"
						>
							<v-icon left> mdi-close </v-icon>
							Eliminar
						</v-btn>
					</v-col>
					<v-col
						cold="12"
						md="4"
						:class="
							!$vuetify.breakpoint.smAndDown
								? 'd-flex justify-end'
								: ''
						"
					>
						<v-btn
							depressed
							:width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
							color="orange"
							dark
							class="mr-2"
							@click="submit"
						>
							<v-icon left> mdi-magnify </v-icon>
							consultar
						</v-btn>
						<v-btn
							text
							color="red"
							:width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
							:class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
							@click="close"
						>
							cerrar
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import ClientDataFilters from './ClientDataFilters.vue';
import ContractDataFilters from './ContractDataFilters.vue';
import AttentionDataFilters from './AttentionDataFilters.vue';

import {
	swapKeysAndValues,
	objectCamelToSnakeCase,
	clone,
} from '@/util/libUtil.js';

export default {
	components: {
		ClientDataFilters,
		AttentionDataFilters,
		ContractDataFilters,
	},
	data: () => ({
		step: 0,
		uploading_form: false,
		attentionFilters: 0,
		clientFilters: 0,
		contractFilters: 0,
	}),
	mounted() {
		if (document.querySelector('.v-slide-group__prev'))
			document.querySelector('.v-slide-group__prev').remove();
	},
	computed: {
		form: {
			get: function () {
				return this.$store.state.teletrabajo.QueryForm;
			},
			set: function (val) {
				this.$store.commit('teletrabajo/QueryForm', val);
			},
		},
		dialogState: {
			get: function () {
				return this.$store.state.teletrabajo.IsOpenTtQueryDialog;
			},
			set: function (val) {
				this.$store.dispatch('teletrabajo/closeTtQueryDialog', val);
			},
		},
	},
	methods: {
		mounted() {
			if (document.querySelector('.v-slide-group__prev'))
				document.querySelector('.v-slide-group__prev').remove();
		},
		orderDates(arr) {
			let date_from = new Date(arr[0]);
			let date_to = new Date(arr[1]);
			if (date_from > date_to) {
				let c = arr[0];
				arr[0] = arr[1];
				arr[1] = c;
			}
			return arr;
		},
		submit() {
			// this.$v.$touch();
			// if (this.$v.$invalid) {
			//     console.log('error!');
			// } else {
			// let offer = JSON.parse(JSON.stringify(this.form))
			// console.log(offer)
			// console.log(this.form)
			// console.log(JSON.parse(JSON.stringify(this.form)))
			let monParams = objectCamelToSnakeCase(this.form);
			// console.log(monParams)
			// encodeQuery(monParams)
			monParams.page = 1;
			this.uploading_form = true;
			console.log(monParams);
			this.$store.dispatch('teletrabajo/updateQueryParams', monParams);
			this.$store.dispatch('teletrabajo/getTableData').then(() => {
				this.$store.dispatch('util/showStatusSnackBar', {
					statusType: 'success',
					message: 'Búsqueda realizada con éxito',
				});
				this.uploading_form = false;
				this.close();
			});
			// .catch(() => {
			//     this.$store.dispatch('util/showStatusSnackBar', {
			//         statusType: 'error',
			//         message: 'Ha habido un error',
			//     });
			//     this.uploading_form = false;
			// });
			this.uploading_form = true;
			// }
		},
		async clearform() {
			await this.$root.$emit('deleteTableFilters');
			this.$store.commit('util/navBarSearchField', '');
		},
		close() {
			// this.$v.$reset();
			this.$store.dispatch('teletrabajo/closeTtQueryDialog');
			//this.clear();
		},
	},
	watch: {
		form: {
			deep: true,
			immediate: true,
			handler: function () {
				if (this.form.fecha_contacto[1]) {
					this.form.fecha_contacto = this.orderDates(
						this.form.fecha_contacto
					);
				}
				if (this.form.updated_on[1]) {
					this.form.updated_on = this.orderDates(
						this.form.updated_on
					);
				}
				if (this.form.fecha_agendado[1]) {
					this.form.fecha_agendado = this.orderDates(
						this.form.fecha_agendado
					);
				}
				if (this.form.fecha_venta[1]) {
					this.form.fecha_venta = this.orderDates(
						this.form.fecha_venta
					);
				}
				if (
					this.form.opciones_tipo_llamada &&
					this.form.opciones_tipo_llamada == 'NC'
				) {
					if (this.form.opciones_no_interesado) {
						this.form.opciones_no_interesado = null;
					}
				}
			},
		},
	},
	mounted() {
		this.$root.$on('attentionFilters', (val) => {
			this.attentionFilters = val;
		});
		this.$root.$on('clientFilters', (val) => {
			this.clientFilters = val;
		});
		this.$root.$on('contractFilters', (val) => {
			this.contractFilters = val;
		});
	},
	created() {
		this.$store.dispatch(
			'ManagementBase/promotionManagement/getTariffDropDown'
		);
	},
};
</script>
